import { Box, FormHelperText, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Select from "./Select";
import TextField from "./TextField";
import {
  MODAL_CANCEL_SUBSCRIPTION_REASON_HELPER_TEXT,
  MODAL_CANCEL_SUBSCRIPTION_REASON_HELPER_TEXT_MIN_CHARS,
  MODAL_CANCEL_SUBSCRIPTION_REASON_PLACEHOLDER,
  CANCELLATION_REASON_SELECT_LABEL,
} from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";

const CancellationReasonForm = ({
  control,
  errors,
  charCount,
  minChars,
  maxChars,
  cancellationReasons,
}) => {
  const { t } = useTranslationApp();
  const theme = useTheme();

  const getHelperTextColor = () => {
    if (charCount >= minChars) return theme.palette.success.main;
    if (charCount > 0) return theme.palette.warning.main;
    return theme.palette.error.main;
  };

  const getBorderColor = () => {
    if (charCount >= minChars) return theme.palette.success.main;
    if (charCount > 0) return theme.palette.warning.main;
    return theme.palette.grey[300];
  };

  return (
    <Box sx={{ mt: 1 }}>
      <Typography variant="body1" sx={{ mb: 1 }}>
        {t(CANCELLATION_REASON_SELECT_LABEL)}
      </Typography>
      <Box sx={{ mb: 2 }}>
        <Select
          control={control}
          name="selectedReasonValue"
          options={cancellationReasons}
          fullWidth
          variant="filled"
          doTranslate={true}
          rules={{}}
          errors={errors}
        />
      </Box>

      <TextField
        variant="filled"
        control={control}
        name="reason"
        rules={{}}
        multiline
        minRows={5}
        maxRows={5}
        fullWidth
        placeholder={t(MODAL_CANCEL_SUBSCRIPTION_REASON_PLACEHOLDER)}
        showCounterCharacters={false}
        maxCharacters={maxChars}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: getBorderColor(),
              borderWidth: 2,
            },
            "&:hover fieldset": {
              borderColor: getBorderColor(),
            },
            "&.Mui-focused fieldset": {
              borderColor: getBorderColor(),
            },
          },
          "& .MuiInputBase-input": {
            fontSize: "14px",
            fontFamily: "inherit",
            resize: "vertical",
          },
        }}
      />

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 0.5,
        }}
      >
        <FormHelperText
          sx={{
            color: getHelperTextColor(),
            fontSize: "12px",
            margin: 0,
          }}
        >
          {charCount >= minChars
            ? t(MODAL_CANCEL_SUBSCRIPTION_REASON_HELPER_TEXT)
            : t(MODAL_CANCEL_SUBSCRIPTION_REASON_HELPER_TEXT_MIN_CHARS, {
                charCount: charCount,
                minChars: minChars,
              })}
        </FormHelperText>

        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
            fontSize: "12px",
          }}
        >
          {charCount}/{maxChars}
        </Typography>
      </Box>
    </Box>
  );
};

export default CancellationReasonForm;
